export default __webpack_public_path__ + "static/media/receiveurphotos.fb225324.webp";